<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="getNeedSignList"
      selectable
      hide-title-search
      title="教工申请补卡"
      v-model="selected"
    ></l-data-table>
    <v-layout column>
      <v-flex v-if="needFileFlag">
        <l-select-file @input="addFile(arguments[0])" title="上传文件">
          <v-btn color="primary" flat slot="activator" :loading="loading">
            上传健康证明<span class="error--text caption"
              >（仅支持图片上传）</span
            >
          </v-btn>
        </l-select-file>
      </v-flex>
      <v-flex v-for="(u, index) in urls">
        <v-layout>
          <v-flex class="pt-3 ml-4" xs1>
            <p>健康证明{{ index + 1 }}</p>
          </v-flex>
          <v-btn flat color="primary" @click="download(u)">点击下载查看</v-btn>
          <v-btn @click="deleteUrl(index)" flat color="primary">删除</v-btn>
        </v-layout>
      </v-flex>
      <v-flex class="pa-3">
        <v-textarea
          v-model="reason"
          auto-grow
          label="补卡原因"
          rows="1"
          hint="如有关于补卡申请的问题请联系人力资源部（028-61831146）咨询"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-btn
        class="primary"
        :loading="loading"
        @click="submit"
        :disabled="disabledFlag"
        >提交补卡申请</v-btn
      >
    </v-layout>
    <hr />
    <v-layout justify-center>
      <v-btn class="primary" :loading="loading" @click="goHistory"
        >个人申请记录（补卡）</v-btn
      >
      <v-btn
        v-if="hasReviewPermission"
        class="primary"
        :loading="loading"
        @click="goReview"
        >二级单位审核</v-btn
      >
    </v-layout>
  </l-layout>
</template>

<script>
import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
import LSelectFile from "../../../ladmin/components/LSelectFile/LSelectFile";
import document from "../../../router/routes/document";
function transType(v) {
  switch (v + "") {
    case "0":
      return "普通类型";
    case "1":
      return "指标异常";
  }
}
export default {
  name: "apply",
  components: { LSelectFile, LDataTable },
  data() {
    return {
      selected: [],
      urls: [],
      needFileFlag: false,
      loading: false,
      disabledFlag: false,
      hasReviewPermission: false,
      reason: "",
      header: [
        { text: "补卡日期", value: "date", sortable: false, align: "left" },
        {
          text: "补卡类型",
          value: "type",
          sortable: false,
          align: "left",
          f: (v) => transType(v),
        },
        { text: "补卡提示", value: "msg", sortable: false, align: "left" },
      ],
    };
  },
  created() {
    let permission = this.$store.state.login.permission;
    if (permission.wechat && permission.wechat.firstAudit) {
      this.hasReviewPermission = true;
    }
  },
  methods: {
    async submit() {
      if (this.needFileFlag && this.urls.length === 0) {
        this.$L.alert("error", { message: "请上传健康证明" });
        return;
      }
      if (this.selected.length === 0) {
        this.$L.alert("error", { message: "请选择需要补卡选项" });
        return;
      }
      if (this.reason === "") {
        this.$L.alert("error", { message: "请填写补卡原因" });
        return;
      }
      let params = {
        normalizeReqLists: this.selected,
        comment: this.reason,
        fileList: this.urls,
      };
      this.loading = true;
      let res = await this.$store.dispatch("school/applyExtraSign", params);
      this.loading = false;
      if (res.data.status == 1) {
        this.$L.alert("success", { message: "申请成功" });
        this.disabledFlag = true;
      } else {
        this.$L.alert("error", { message: "申请失败，原因是:" + res.data.msg });
      }
    },
    getLoginInfo() {
      return JSON.parse(sessionStorage.getItem("loginInfo"));
    },
    deleteUrl(index) {
      this.urls.splice(index, 1);
    },
    download(url) {
      let isSupportDownload = "download" in window.document.createElement("a");
      console.log("get url", url, isSupportDownload);
      let el = window.document.createElement("a");
      el.href = "https://smaco2.uestc.edu.cn/passObjectApi" + url;
      el.target = "_blank";
      el.download = "健康证明";
      el.style.display = "none";
      window.document.body.appendChild(el);
      el.click();
      window.document.body.removeChild(el);
    },
    goHistory() {
      this.$router.push("/wx/selfExtraReviewList");
    },
    goReview() {
      this.$router.push("/wx/firstExtraReviewList");
    },
    async getNeedSignList({ pagination }) {
      let res = await this.$store.dispatch("school/getNeedSignList", {
        pagination: pagination,
        search: { key: "loginId", value: this.getLoginInfo().id },
      });
      if (res.data.status === 1) {
        let items = res.data.data;
        for (let i in items) {
          items[i].id = i;
          if (items[i].type === 1) {
            this.needFileFlag = true;
          }
        }
        return { items: items, amount: items.length };
      } else {
        this.$L.alert("error", { message: res.data.msg });
      }
    },
    async addFile(file) {
      this.loading = true;
      let url = await this.uploadFile(file);
      this.loading = false;
      this.urls.push(url);
    },
    async uploadFile(files) {
      if (files instanceof Object && files.length > 0) {
        let file = files[0];
        try {
          let res = await this.$store.dispatch("uploadFile", {
            file,
            url: "/passObjectApi/temp/file",
          });
          return res;
        } catch (e) {
          this.$L.alert("error", { message: "上传失败" + e.toString() });
        }
      }
    },
  },
};
</script>

<style scoped>
</style>
